module.exports = __webpack_public_path__ + "static/mark-twain-d8463ecc856daa56fe5a1ec744a85faa.jpg";